export default "__VITE_ASSET__CG_95n$5__"